import { Modal, Button } from "antd";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import React, { useEffect, useRef } from "react";
import GalkButton from "../../common/component/button";

function usePrevious(value) {
	const ref = useRef();
	useEffect(() => {
		ref.current = value;
	});
	return ref.current;
}

const ProfileCompletedModal = ({
	modalCloseHandler,
	isActionProgress,
	createGalkLabJob,
}) => {
	const prevActionInProgressValue = usePrevious(isActionProgress);

	const history = useHistory();
	const goToHome = () => {
		history.push("/home");
	};

	useEffect(() => {
		if (!isActionProgress && prevActionInProgressValue) {
			modalCloseHandler();
		}
	}, [isActionProgress]); // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<Modal
			title="Profile completed"
			visible={true}
			onCancel={modalCloseHandler}
			footer={null}
		>
			Profile Creation is completed. You can access other features of the Portal
			by going to home page or continue editing profile.
			<div style={{ margin: "10px" }}></div>
			<div style={{}}>
				<GalkButton
					width={90}
					type="primary"
					onClick={() => {
						modalCloseHandler();
						goToHome();
					}}
				>
					Home
				</GalkButton>

				<GalkButton width={90} type="primary" onClick={modalCloseHandler}>
					Continue
				</GalkButton>
			</div>
		</Modal>
	);
};

const mapStateToProps = (state) => ({
	isActionProgress: state.galkLabJobs.actionInProgress,
});

export default connect(mapStateToProps, {})(ProfileCompletedModal);
